import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { FormContext } from "../Store/form-context";
import useDnsFetch from "../hooks/useDnsFetch";

import HeroWrapper from "../components/HeroWrapper/HeroWrapper";
import TabWrapper from "../components/TabWrapper/TabWrapper";
import SearchBox from "../components/SearchBox/SearchBox";
import ResultBox from "../components/ResultBox/ResultBox";
import DNSTabWrapper from "../components/TabWrapper/DNSTabWrapper";

const DomainLookup = () => {
	const { state, dispatch } = React.useContext(FormContext);
	const inputRef = React.createRef();
	const { dnsData } = useDnsFetch(
		state.dns.isValid,
		state.dns.inputValue.toLowerCase(),
		state.dns.dnsType,
	);

	const location = useLocation();
	const [, setSearchParams] = useSearchParams();

	React.useEffect(() => {
		const urlPath = location.pathname.replace("/", "");
		dispatch({
			type: "CHANGE_TAB_TYPE",
			payload: { tabType: urlPath === "" ? "dns" : urlPath },
		});
	}, [location.pathname, dispatch]);

	React.useEffect(() => {
		const domainNameParam = new URLSearchParams(location.search).get("domain");

		if (domainNameParam) {
			dispatch({
				type: "ADD_DNS",
				payload: { inputValue: domainNameParam.toLowerCase() },
			});
			dispatch({
				type: "ADD_RDAP",
				payload: { inputValue: domainNameParam.toLowerCase() },
			});
		}
	}, [location.search, dispatch]);

	React.useEffect(() => {
		if (dnsData.data) setSearchParams({ domain: state.dns.inputValue });
	}, [dnsData, setSearchParams, state.dns.inputValue]);

	const inputChangeHandler = (e) => {
		dispatch({ type: "ADD_DNS", payload: { inputValue: e.target.value } });
		dispatch({ type: "ADD_RDAP", payload: { inputValue: e.target.value } });
	};

	return (
		<>
			<Helmet>
				<title>Domaintools - DNS DIG</title>
				<meta name="description" content="See the DNS records for a domain" />
				<link rel="canonical" href="https://domaintools.nu/dns" />
			</Helmet>
			<HeroWrapper text="DNS DIG" />
			<TabWrapper />

			<div className="search-container">
				<div className="search-box">
					<SearchBox
						inputName="dns"
						value={state.dns.inputValue}
						inputChangeHandler={inputChangeHandler}
						placeholderValue="example.com"
						inputRef={inputRef}
						isLoading={dnsData.loading}
						isValid={state.dns.isValid}
					/>
					<DNSTabWrapper />
				</div>
			</div>

			<ResultBox
				tabType={state.tabType}
				data={dnsData.data}
				domainType={state.dns.dnsType}
				error={dnsData.error}
			/>
		</>
	);
};

export default DomainLookup;
